<template>
  <v-card width="94%" elevation="0" class="ml-5">
    <v-container>
      <v-row>
        <v-textarea
          style="font-family: monospace"
          v-model="TLEText"
          label="TLEs"
          full-width
          outlined
          rows="3"
        ></v-textarea>
      </v-row>
      <v-row class="mb-5">
        <v-col>
          <input type="checkbox" id="checkbox" v-model="filterTLEs" />
          <label for="checkbox" class="ml-1"
            >Filtering potential wrong TLEs</label
          >
          <em v-if="filterTLEs" class="ml-10" style="color: #4472bb"
            >Warning: Some outliers might remain and some maneuvers could be
            removed.
          </em>
        </v-col>
      </v-row>
      <v-row
        class="mb-n6"
        style="display: flex; justify-content: space-evenly"
        v-if="data"
      >
        <v-col v-for="label in labels" :key="label.name">
          <v-card
            class="pa-2 justify-start d-flex"
            :style="
              'background: ' +
              getLabelColor(label.name) +
              '; color: #ffffff; font-size: 150%'
            "
            >Total Δ{{ label.name }} = {{ getTotalValue(label) }}</v-card
          >
        </v-col>
      </v-row>
      <v-row style="display: flex; justify-content: space-evenly" v-if="data">
        <v-col v-for="label in labels" :key="label.name">
          <ExpandableTLECard
            :title="'Show details'"
            :emptyMessage="'No data'"
            :root="_self"
            :isExpanded="isExpanded"
            :smaller="true"
            :values="data.maxManeuvers[label.name]"
            :disabled="disabled"
            :structure="structure"
            :centered="false"
            headerColor="#FFFFFF"
            :background="getLabelColor(label.name)"
            subtitleColor="#FFFFFF"
            valuesColor="#FFFFFF"
            emptyColor="white"
            v-on:expand="isExpanded = $event"
            :oneLine="true"
          ></ExpandableTLECard>
        </v-col>
      </v-row>
      <v-row
        v-if="data"
        class="pt-10"
        style="display: flex; justify-content: space-evenly"
      >
        <div
          v-for="graph in graphs"
          :id="graph.divId"
          style="width: 33%; height: 350px"
        ></div>
      </v-row>
      <v-row
        v-if="data"
        class="mt-5"
        style="display: flex; justify-content: space-evenly"
      >
        <div style="width: 33%"></div>
        <div style="width: 33%"></div>
        <div style="width: 33%">
          <v-btn
            color="#2a94de"
            v-on:click="downloadDetails"
            style="float: right"
            ><span class="white--text">EXPORT DETAILS</span></v-btn
          >
        </div>
      </v-row>
      <v-row
        v-if="data == null"
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          height: 350px;
        "
      >
        <span class="grey--text" v-if="error == null">
          Copy paste your list of TLE to display the Δ𝑉 calcultions
        </span>
        <span class="red--text" v-else>
          {{ error }}
        </span>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import moment from 'moment'
import dataDescription from '../../tools/dataDescription.json'
import dataTools from '../../tools/data.js'
import ExpandableTLECard from './ExpandableTLECard.vue'
import Plotly from 'plotly.js-dist'

export default {
  name: 'TLEDeltaV',

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },

  components: {
    ExpandableTLECard
  },

  data() {
    return {
      TLEText: '',
      value: null,
      error: null,
      filterTLEs: false,
      isExpanded: false,
      structure: [
        {
          title: '',
          data: [
            [
              {
                label: 'Max ΔV',
                dataField: 'maxv',
                type: 'velocity',
                small: true,
                fontsize: '150%'
              }
            ],
            [
              {
                label: 'Max Δsma',
                dataField: 'maxsma',
                type: 'distance',
                small: true,
                fontsize: '150%'
              }
            ],
            [
              {
                label: 'Max Δinc',
                dataField: 'maxinc',
                type: 'angle',
                small: true,
                fontsize: '150%'
              }
            ],
            [
              {
                label: 'Max Δecc',
                dataField: 'maxecc',
                type: 'coefficient',
                small: true,
                fontsize: '150%'
              }
            ],
            [{ label: 'from TLE date', dataField: 'idate', type: 'date' }],
            [{ label: 'to TLE date', dataField: 'fdate', type: 'date' }],
            [{ label: 'Δv', dataField: 'v', type: 'velocity', small: true }],
            [
              { label: 'Δsma', dataField: 'sma', type: 'distance', small: true }
            ],
            [{ label: 'Δinc', dataField: 'inc', type: 'angle', small: true }],
            [
              {
                label: 'Δecc',
                dataField: 'ecc',
                type: 'coefficient',
                small: true
              }
            ]
          ]
        }
      ],
      graphs: [
        {
          label: 'semi-major axis',
          prop: 'sma',
          divId: 'smaPlotDiv',
          yType: 'distance',
          tickformat: '.5g'
        },
        {
          label: 'inclination',
          prop: 'inclination',
          divId: 'incPlotDiv',
          yType: 'angle',
          tickformat: '.5g'
        },
        {
          label: 'eccentricity',
          prop: 'eccentricity',
          divId: 'eccPlotDiv',
          yType: 'coefficient'
        }
      ],
      plotConfig: { responsive: true },
      data: null,
      labels: [
        { name: 'v', type: 'velocity' },
        { name: 'sma', type: 'distance' },
        { name: 'inc', type: 'angle' },
        { name: 'ecc', type: 'coefficient' }
      ]
    }
  },

  mounted() {},

  watch: {
    async TLEText() {
      this.updateData()
    },
    async filterTLEs() {
      this.updateData()
    },
    async data() {
      await this.$nextTick()
      if (this.data) {
        this.graphs.forEach((graph) => this.drawGraph(graph))
      }
    }
  },

  computed: {},

  methods: {
    getTotalValue(label) {
      const value = this.data.totals[label.name]
      if (value === '' || value == null || value === undefined) {
        return ''
      }
      const convertedValue = dataTools.convertSi2gui(label.type, value)
      let result
      if (label.type === 'date' || Math.abs(convertedValue) >= 0.1) {
        result = dataTools.convertSi2gui(label.type, value)
        result = dataTools.displayNdigits(result, 3)
        result = result === '-0' ? '0' : result
      } else {
        result = convertedValue.toExponential(3)
      }
      const unit = dataTools.getUnitDisplayed(
        dataTools.getDefaultGuiUnit(label.type)
      )
      return unit ? `${result} ${unit}` : result
    },
    async updateData() {
      if (this.TLEText === '') {
        this.data = null
        this.error = null
        return
      }
      const tles = this.parseTLEs(this.TLEText)
      if (tles == null) {
        this.data = null
        this.error = 'Invalid TLE'
        return
      }
      if (tles.length > 4000) {
        this.data = null
        this.error = `The number of TLEs should be less than 2000. There currently are ${Math.floor(
          tles.length / 2
        )} TLEs.`
        return
      }
      const { results, error } = await this.getValueFromServer(
        tles,
        this.filterTLEs
      )
      if (error == null && results != null) {
        if (results.maneuverOrbits.length === 0) {
          this.data = null
          this.error = 'No maneuver detected'
        }

        const data = {}

        data.maxManeuvers = this.getMaxManeuversFromResults(results)
        data.totals = {
          v: results.totalDeltaV,
          ecc: results.totalEccentricity,
          inc: results.totalInclination,
          sma: results.totalSma
        }
        data.graphs = this.getGraphDataFromResults(results)
        data.satelliteNumber = results.satelliteNumber
        data.details = this.getDetails(results)
        this.data = data
        this.error = null
      } else {
        this.data = null
        this.error = error ? error : 'Error while decoding TLE'
      }
    },
    getValueFromServer(tles, filterTLEs) {
      return this.$http
        .post('/physics/tledeltavcalculator', {
          tles: tles,
          filterTLEs: filterTLEs
        })
        .then(function (response) {
          return { results: response.data, error: null }
        })
        .catch((e) => {
          let error
          if (e.response && e.response.status === 400) {
            error = e.response.data
          } else {
            error =
              'An error occured while trying to communicate with the server'
          }
          return { results: null, error: error }
        })
    },
    parseTLEs(TLEText) {
      const regex_tle =
        /\s*(?:(?<name>.{1,24})\s*\n)?\s*(?<l1>.{69})\s*\n\s*(?<l2>.{69})\s*/g
      const regex_tles =
        /^(?:\s*(?:.{1,24}\s*\n)?\s*.{69}\s*\n\s*.{69}\s*)(?:\n\s*(?:.{1,24}\s*\n)?\s*.{69}\s*\n\s*.{69}\s*)*$/
      if (regex_tles.test(TLEText)) {
        const tles = []
        const matches = [...TLEText.matchAll(regex_tle)]
        matches.forEach((TLE) => {
          tles.push(TLE.groups.l1)
          tles.push(TLE.groups.l2)
        })
        return tles
      } else {
        return null
      }
    },
    getMaxManeuversFromResults(results) {
      const maxManeuversReports = results.deltaVCalculatorMaxManeuverReports
      const regex_type = /^MAX_DELTA_(?<type>.+)$/
      const maxManeuvers = {}
      const measures = [
        { type: 'v', label: 'maneuverDeltaV' },
        { type: 'sma', label: 'maneuverDeltaSma' },
        { type: 'inc', label: 'maneuverDeltaInclination' },
        { type: 'ecc', label: 'maneuverDeltaEccentricity' }
      ]
      for (const maxManeuverReport of maxManeuversReports) {
        if (maxManeuverReport != null) {
          let type =
            maxManeuverReport.reportType.match(regex_type)?.groups?.type
          if (type) {
            type = type.toLowerCase()
            maxManeuvers[type] = {}
            for (const measure of measures) {
              if (measure.type === type) {
                maxManeuvers[type]['max' + measure.type] =
                  maxManeuverReport[measure.label]
              } else {
                maxManeuvers[type][measure.type] =
                  maxManeuverReport[measure.label]
              }
            }
            maxManeuvers[type].idate = moment
              .utc(maxManeuverReport.maneuverInitialDate)
              .format()
            maxManeuvers[type].fdate = moment
              .utc(maxManeuverReport.maneuverFinalDate)
              .format()
          }
        }
      }
      return maxManeuvers
    },
    getGraphDataFromResults(results) {
      const graphsData = {}
      this.graphs.forEach((graph) => {
        const x = results.usedOrbits.map((orbit) => orbit.orbitDateTime)
        const y = results.usedOrbits.map((orbit) => orbit[graph.prop])
        const xDiscarded = results.discardedOrbits.map(
          (orbit) => orbit.orbitDateTime
        )
        const yDiscarded = results.discardedOrbits.map(
          (orbit) => orbit[graph.prop]
        )

        graphsData[graph.label] = { x, y, xDiscarded, yDiscarded }
      })
      return graphsData
    },
    drawGraph(graph) {
      const plotDiv = document.getElementById(graph.divId)
      const unit = dataTools.getUnitDisplayed(
        dataTools.getDefaultGuiUnit(graph.yType)
      )
      const plotLayout = {
        xaxis: {
          title: { text: 'Time (Days)' }
        },
        yaxis: {
          title: {
            text: `Mean ${graph.label} ${unit ? '(' + unit + ')' : ''}`
          },
          tickformat: graph.tickformat ? graph.tickformat : '.3g'
        },
        margin: { t: 0 }
      }
      Plotly.newPlot(
        plotDiv,
        [
          {
            x: this.data.graphs[graph.label].x,
            y: this.data.graphs[graph.label].y.map((y) =>
              dataTools.convertSi2gui(graph.yType, y)
            ),
            type: 'scatter',
            name: 'orbits'
          },
          {
            x: this.data.graphs[graph.label].xDiscarded,
            y: this.data.graphs[graph.label].yDiscarded.map((y) =>
              dataTools.convertSi2gui(graph.yType, y)
            ),
            type: 'scatter',
            mode: 'markers',
            name: 'outliers'
          }
        ],
        plotLayout,
        this.plotConfig
      )
    },
    getLabelColor(label) {
      switch (label) {
        case 'v':
          return '#2a94de'
          break
        case 'sma':
          return '#ff7e0d'
          break
        case 'inc':
          return '#f72c2c'
          break
        case 'ecc':
          return '#70ad47'
          break
        default:
          return 'black'
      }
    },
    getDetails(results) {
      var final = ''
      results.deltaVCalculatorDailyManeuverReports.forEach(
        (maneuver, index) => {
          final =
            final +
            `ORBITAL CHANGE ${index + 1}\n` +
            `Between ${maneuver.maneuverInitialDate} & ${maneuver.maneuverFinalDate}\n` +
            `   delta sma (${dataTools.getDefaultGuiUnit(
              'distance'
            )}): ${dataTools.convertSi2gui(
              'distance',
              maneuver.maneuverDeltaSma
            )}\n` +
            `   delta inc (${dataTools.getDefaultGuiUnit(
              'angle'
            )}): ${dataTools.convertSi2gui(
              'angle',
              maneuver.maneuverDeltaInclination
            )}\n` +
            `   delta eccentricity: ${dataTools.convertSi2gui(
              'coefficient',
              maneuver.maneuverDeltaEccentricity
            )}\n` +
            `   DV (${dataTools.getDefaultGuiUnit(
              'velocity'
            )}): ${dataTools.convertSi2gui(
              'velocity',
              maneuver.maneuverDeltaV
            )}\n\n`
        }
      )
      return final
    },
    downloadDetails() {
      if (this.data) {
        const url = window.URL.createObjectURL(new Blob([this.data.details]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `TLE_DeltaV_Results_${this.data.satelliteNumber}.txt`
        )
        document.body.appendChild(link)
        link.click()
      }
    }
  }
}
</script>
